import { useState } from 'react'
import { useInventoriesApiClient } from '@/api/inventories/useInventoriesApiClient.ts'
import { useDownloadExcelFile } from '@/presentation/common/hooks/crud/v2/useDownloadExcelFile.ts'

export const useDownloadInventoriesExcel = () => {
  const repository = useInventoriesApiClient()
  const query = useDownloadExcelFile<void>({
    filename : 'inventories.xlsx',
    callable : repository.downloadExcelResume,
    messages : {
      default : 'Error al generar archivo',
      loading : 'Generando archivo',
      success : 'Archivo generado',
    },
  })

  const [ data, setData ] = useState<File>()

  const submit = async () => {
    const response = await query.submit()
    setData(response)
  }

  return {
    ...query,
    submit,
    data,
  }
}
